import { getDeviceInfo } from "@/utils/Device";
import { getUser } from "@/utils/User";
import { isLocalhost, backendApi, getServerType } from "@/utils/URL";
import { defaultParams } from '@/utils/Backend';

export const sendLogs = async (language, message, details = '') => {

    if(!isLocalhost()){
        
        const msgStr = typeof message === 'string' ? message : (message?.message || (message ? JSON.stringify(message) : ''));

        if(
            !msgStr.includes('Unable to preload CSS') &&
            !msgStr.includes('Failed to fetch dynamically imported module') &&
            !msgStr.includes('error loading dynamically imported module') &&
            !msgStr.includes('Importing a module script failed') &&
            !msgStr.includes('The node to be removed is not a child of this node') &&
            !msgStr.includes('The node before which the new node is to be inserted is not a child of this node') &&
            !msgStr.includes('insertBefore')
        ){

            const device = getDeviceInfo();

            const user = getUser();

            const from = 'frontend '+getServerType();

            const defaults = defaultParams(language);

            const data = {
                ...defaults,
                from: from,
                log: JSON.stringify(message),
                url: window.location.href,
                device: device,
                user: user?.email
            };

            if(details.length > 0){
                data.details = details;
            }

            const apiUrl = backendApi();

            if(apiUrl){
                await window.axios.post(apiUrl+'/log',data);
                /*.then(function (response){
                })
                .catch(function (error){
                });*/
            }
        }
    }
}